export default {
    createYourPassword: 'เปลี่ยนรหัสผ่าน',
    newPassword: 'สร้างรหัสผ่าน',
    enterNewPassword: 'ระบุรหัสผ่าน',
    confirmedPassword: 'ยืนยันรหัสผ่าน',
    enterConfirmedPassword: 'ระบุรหัสผ่านอีกครั้ง',
    login: 'เข้าสู่ระบบ',
    newPasswordIsRequired: 'ระบุระบุรหัสผ่านใหม่',
    confirmedPasswordRequired: 'ระบุระบุรหัสผ่านใหม่อีกครั้ง',
    passwordIsNotMatch: 'Password is not match'
}
